import { render, staticRenderFns } from "./EditItem.vue?vue&type=template&id=5e8693bd&scoped=true"
import script from "./EditItem.vue?vue&type=script&lang=js"
export * from "./EditItem.vue?vue&type=script&lang=js"
import style0 from "./EditItem.vue?vue&type=style&index=0&id=5e8693bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8693bd",
  null
  
)

export default component.exports